import { render, staticRenderFns } from "./personnel-select-widget.vue?vue&type=template&id=097e5d73&scoped=true&"
import script from "./personnel-select-widget.vue?vue&type=script&lang=js&"
export * from "./personnel-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./personnel-select-widget.vue?vue&type=style&index=0&id=097e5d73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e5d73",
  null
  
)

export default component.exports